<template>
  <div
    class="modal"
    id="NodeEditor"
    role="dialog"
    tabindex="-1"
    aria-labelledby="demo-default-modal"
    aria-hidden="true"
    data-backdrop="static"
    style="display: none"
  >
    <div class="modal-dialog" style="width: 880px">
      <div class="modal-content">
        <!--Modal header-->
        <div class="modal-header">
          <h4 class="modal-title">{{ nodeid ? '编辑工序' : '新建工序' }}</h4>
        </div>
        <!--Modal body-->
        <div class="modal-body" style="padding-top: 0">
          <div class="loading" v-if="nodeid && !model">加载中…</div>
          <div class="" v-if="ready">
            <!--Panel heading-->
            <div class="panel-heading">
              <div class="panel-control new-node-tabs" style="padding: 0">
                <ul id="Tab" class="nav nav-tabs">
                  <li class="active">
                    <a href="#NewNodeBase" data-toggle="tab">基本信息</a>
                  </li>
                  <li>
                    <a href="#NewNodeForm" data-toggle="tab">反馈内容</a>
                  </li>
                </ul>
              </div>
            </div>

            <!--Panel body-->
            <div class="panel-body">
              <div class="tab-content">
                <div class="tab-pane fade in active" id="NewNodeBase">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label class="col-md-2 control-label">所属步骤</label>
                      <div class="col-md-9">
                        <p class="form-control-static">步骤 {{ step + 1 }}</p>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        class="col-md-2 control-label"
                        for="demo-text-input"
                        >工序名称</label
                      >
                      <div class="col-md-9">
                        <el-select
                          v-model="node.code"
                          filterable
                          popper-class="node-popper-select"
                          size="small"
                          placeholder="请选择"
                        >
                          <el-option
                            :key="0"
                            label="请选择"
                            :value="0"
                            disabled
                          ></el-option>
                          <el-option
                            v-for="(value, name) in nodes"
                            :key="name"
                            :label="value.name"
                            :value="parseInt(name)"
                          >
                          </el-option>
                        </el-select>
                        <small
                          class="mar-lft text-danger"
                          v-show="!node.code > 0"
                          >{{ errorMsg }}</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        class="col-md-2 control-label"
                        for="demo-text-input"
                        >图片备注</label
                      >
                      <div class="col-md-9">
                        <upload
                          v-model="node.imgs"
                          :limit="5"
                          size="small"
                        ></upload>
                      </div>
                    </div>
                    <!-- <div class="form-group">
                      <label
                        class="col-md-2 control-label"
                        for="demo-text-input"
                        >工序名称</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          id="demo-text-input"
                          class="form-control"
                          placeholder="输入工序名称"
                          v-model="node.title"
                        />
                        <small class="help-block">最大长度为40字</small>
                      </div>
                    </div> -->
                    <!-- <div class="form-group">
                      <label class="col-md-2 control-label" for="demo-text-input">标准工时</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          id="demo-text-input"
                          class="form-control"
                          placeholder="输入标准工时"
                          v-model="node.manhour"
                        />
                        <small class="help-block">单位：小时</small>
                      </div>
                    </div> -->

                    <div class="form-group">
                      <label
                        class="col-md-2 control-label"
                        for="demo-text-input"
                        >工时标准</label
                      >
                      <div class="col-md-9">
                        <div class="form-control-static">
                          <template v-if="node.code > 0 && nodes[node.code]">
                            <span
                              style="margin-right: 10px"
                              v-for="(item, key) in nodes[node.code].sizes"
                            >
                              {{ key }}:
                              <span style="font-weight: bold"
                                >{{ item.val }}min</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span>无</span>
                          </template>
                        </div>
                        <!-- <small class="help-block">单位：小时</small> -->
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        class="col-md-2 control-label"
                        for="demo-text-input"
                        >是否强制检查</label
                      >
                      <div class="col-md-9 checkbox">
                        <input
                          id="IsStartNow"
                          class="magic-checkbox"
                          type="checkbox"
                          v-model="node.focus_checked"
                        />
                        <label for="IsStartNow"></label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">分配方式</label>
                      <div class="col-md-9">
                        <div class="radio">
                          <input
                            id="NodeMode1"
                            class="magic-radio"
                            type="radio"
                            value="1"
                            v-model="mode"
                          />
                          <label for="NodeMode1"
                            >手动分配 - 可以随时为此工序分配执行人员</label
                          >
                        </div>
                        <div class="radio">
                          <input
                            id="NodeMode2"
                            class="magic-radio"
                            type="radio"
                            value="2"
                            v-model="mode"
                          />
                          <label for="NodeMode2"
                            >自动分配 -
                            预设执行人员，在上一步骤完成后自动分配</label
                          >
                        </div>
                        <div class="radio">
                          <input
                            id="NodeMode3"
                            class="magic-radio"
                            type="radio"
                            value="3"
                            v-model="mode"
                          />
                          <label for="NodeMode3"
                            >人员抢单 -
                            预设执行人员，在上一步骤完成后预设人员均可点击完成，但仅限一人完成该任务</label
                          >
                        </div>
                      </div>
                    </div>
                    <div v-if="mode == 2 || mode == 3" class="form-group">
                      <label
                        class="col-md-2 control-label"
                        for="demo-text-input"
                        >预设执行人员</label
                      >
                      <div class="col-md-9">
                        <user-selector v-model="users"></user-selector>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="tab-pane fade" id="NewNodeForm">
                  <div class="editor">
                    <draggable
                      :list="formComponents"
                      :group="{ name: 'components', pull: 'clone', put: false }"
                      :clone="cloneComponent"
                      :step="false"
                      @ended="endDrag"
                      class="form-components"
                      ghost-class="ghost"
                    >
                      <div
                        v-for="item in formComponents"
                        group="components"
                        class="item"
                        :key="item.type"
                      >
                        <span>{{ item.title }}</span>
                        <span :class="item.icon"></span>
                      </div>
                    </draggable>
                    <div class="form-editor">
                      <draggable
                        :list="selectedComponents"
                        group="components"
                        class="eidtor-zone"
                        @add="addComponent"
                      >
                        <div
                          v-for="(item, index) in selectedComponents"
                          class="form-group edit-component"
                          :class="{ selected: item == editingComponent }"
                          @click="switchEditing(index)"
                          v-bind:key="index"
                        >
                          <label class="control-label">
                            {{ item.title }}
                            <span v-if="item.unit.length > 0"
                              >（{{ item.unit }}）</span
                            >
                            <span v-if="item.required">*</span>
                          </label>
                          <div
                            v-if="dispalyInput(item.type)"
                            class="form-control info"
                          >
                            {{ item.placeholder }}
                          </div>
                          <div v-if="dispalyOptions(item.type)">
                            共{{ item.options.length }}个选项
                          </div>
                          <div
                            v-if="item.type == 6"
                            class="form-control date-component"
                          >
                            <label>选择日期</label>
                            <span class="ti-calendar"></span>
                          </div>
                          <div v-if="item.type == 7" class="row">
                            <div class="col-sm-6">
                              <div class="form-control date-component">
                                <label>开始日期</label>
                                <span class="ti-calendar"></span>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-control date-component">
                                <label>结束日期</label>
                                <span class="ti-calendar"></span>
                              </div>
                            </div>
                          </div>
                          <div v-if="item.type == 8" class>
                            <span class="btn btn-primary">选择图片</span>
                          </div>
                          <div v-if="item.type == 9" class>
                            <span class="btn btn-primary">选择附件</span>
                          </div>
                          <span
                            @click="removeComponent(item)"
                            class="close ti-close"
                          ></span>
                        </div>
                      </draggable>
                      <div
                        class="no-tips"
                        v-if="selectedComponents.length == 0"
                      >
                        拖拽左侧控件至此处
                      </div>
                    </div>
                    <div class="component-set">
                      <template v-if="editingComponent != null">
                        <div class="form-group">
                          <label class="control-label">
                            标题
                            <span class="info">最多40字</span>
                          </label>
                          <input
                            v-model="editingComponent.title"
                            type="text"
                            class="form-control"
                          />
                        </div>
                        <div
                          v-if="dispalyPlaceholder(editingComponent.type)"
                          class="form-group"
                        >
                          <label class="control-label">
                            提示文字
                            <span class="info">最多40字</span>
                          </label>
                          <input
                            v-model="editingComponent.placeholder"
                            type="text"
                            class="form-control"
                          />
                        </div>
                        <div
                          v-if="dispalyOptions(editingComponent.type)"
                          class="form-group"
                        >
                          <label class="control-label">
                            选项
                            <span class="info"
                              >最多创建10个选项，单个选项最多40字</span
                            >
                          </label>
                          <label
                            v-if="repeatOptionIndexes.length > 0"
                            class="has-warning"
                          >
                            <small class="help-block">出现重复项</small>
                          </label>
                          <draggable :list="options">
                            <div
                              class="component-option"
                              v-for="(option, index) in options"
                              :class="{ repeat: repeatOption(index) }"
                              v-bind:key="index"
                            >
                              <span class="move ti-list"></span>
                              <input
                                class="form-control"
                                v-model="options[index]"
                              />
                              <span
                                @click="removeOption(index)"
                                class="delete ti-trash"
                              ></span>
                            </div>
                            <div
                              v-if="editingComponent.options.length < 10"
                              slot="footer"
                              class
                              role="group"
                            >
                              <button class="btn btn-info" @click="addOption">
                                添加选项
                              </button>
                            </div>
                          </draggable>
                        </div>
                        <div
                          v-if="displayDate(editingComponent.type)"
                          class="form-group"
                        >
                          <label class="control-label">日期格式</label>
                          <div
                            class="radio"
                            v-for="(type, index) in dateTypes"
                            v-bind:key="index"
                          >
                            <input
                              :id="'DateTypeRadio' + index"
                              class="magic-radio"
                              type="radio"
                              :value="type.value"
                              v-model="editingComponent.dateType"
                            />
                            <label :for="'DateTypeRadio' + index">{{
                              type.label
                            }}</label>
                          </div>
                        </div>
                        <div
                          v-if="editingComponent.type == 3"
                          class="form-group"
                        >
                          <label class="control-label">单位</label>
                          <input
                            v-model="editingComponent.unit"
                            type="text"
                            class="form-control"
                          />
                        </div>
                        <div
                          v-if="editingComponent.type == 8"
                          class="form-group"
                        >
                          <label class="control-label"
                            >最多可以添加9张图片，支持格式png、jpg、jpeg</label
                          >
                        </div>
                        <div
                          v-if="editingComponent.type == 9"
                          class="form-group"
                        >
                          <label class="control-label"
                            >一次只能添加一个附件</label
                          >
                        </div>
                        <div class="form-group">
                          <label class="control-label">标题</label>
                          <div>
                            <input
                              id="ComponentChecked"
                              class="magic-checkbox"
                              type="checkbox"
                              v-model="editingComponent.required"
                            />
                            <label for="ComponentChecked">必填项</label>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Modal footer-->
        <div class="modal-footer">
          <button data-dismiss="modal" class="btn btn-default" type="button">
            取消
          </button>
          <button class="btn btn-primary" @click="postCreateNode">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import upload from '@/components/mult_upload'
import draggable from 'vuedraggable'
import { required } from 'vuelidate/lib/validators'
import {
  newFlowNode,
  flowNodeDetail,
  updateFlowNode,
  flowNodes,
  processList,
} from '@/service/getData'
import UserSelector from '@/components/UserSelector'

export default {
  name: 'newnode',
  components: {
    draggable,
    UserSelector,
    upload,
  },
  props: {
    flowId: Number,
    step: Number,
    nodeid: Number,
  },
  watch: {},
  data() {
    return {
      errorMsg: '',
      nodes: {},
      model: null,
      node: {
        id: null,
        step: 0,
        code: 0,
        title: '',
        mode: 1,
        mode_value: '',
        manhour: 0,
        focus_checked: false,
        flow_template_id: this.flowId,
        imgs: [],
      },
      mode: '1',
      users: {
        type: 0,
        values: [],
      },
      tabIndex: 0,
      formComponents: [
        {
          title: '单行文本',
          icon: 'ti-text',
          type: 1,
        },
        // {
        //   title: '多行文本',
        //   icon: 'ti-smallcap',
        //   type: 2
        // },
        {
          title: '数字',
          icon: '',
          type: 3,
        },
        {
          title: '单项选择',
          icon: 'ti-check',
          type: 4,
        },
        {
          title: '多项选择',
          icon: 'ti-check-box',
          type: 5,
        },
        {
          title: '日期',
          icon: 'ti-calendar',
          type: 6,
        },
        // {
        //   title: '日期区间',
        //   icon: 'ti-calendar',
        //   type: 7
        // },
        {
          title: '图片',
          icon: 'ti-image',
          type: 8,
        },
        // ,
        // {
        //   title: '附件',
        //   icon: 'ti-file',
        //   type: 9
        // }
      ],
      selectedComponents: [],
      editingComponent: null,
      repeatOptionIndexes: [],
      dateTypes: [
        {
          label: '年-月-日',
          value: 'yyyy-MM-dd',
        },
        {
          label: '年-月-日 时:分',
          value: 'yyyy-MM-dd HH:mm',
        },
      ],
    }
  },
  computed: {
    options() {
      if (!this.editingComponent) {
        return []
      }
      return this.editingComponent.options
    },
    ready() {
      return !this.nodeid || (this.nodeid && this.model)
    },
  },
  mounted() {
    $('#NodeEditor').on('hidden.bs.modal', this.resetData)
  },
  watch: {
    editingComponent(nv) {
      this.repeatOptionIndexes = []
    },
    nodeid(newv) {
      if (newv && newv > 0) {
        this.requestNodeDetail()
      }
    },
    users(newv) {
      console.log(newv)
    },
    options(nv) {
      if (!nv) {
        return
      }
      this.repeatOptionIndexes = []
      var dict = {}
      nv.map((item, index) => {
        if (!dict[item]) {
          dict[item] = []
        }
        dict[item].push(index)
      })

      for (let key in dict) {
        if (dict[key].length > 1) {
          this.repeatOptionIndexes = this.repeatOptionIndexes.concat(dict[key])
        }
      }
    },
  },
  created() {
    this.getNodes()
  },
  methods: {
    async getNodes() {
      // let res = await flowNodes()
      // this.nodes = res.data.nodes
      // console.log(this.nodes)

      let res = await processList()
      let nodes = {}
      res.data.map((item) => {
        nodes[item.id] = {
          name: item.name,
          sizes: item.sizes,
        }
      })

      this.nodes = nodes
    },
    cloneComponent(data) {
      return {
        title: data.title,
        type: data.type,
        placeholder: '请输入',
        unit: '',
        required: false,
        options: ['选项1'],
        dateType: 'yyyy-MM-dd',
      }
    },
    endDrag(e) {
      console.log(e)
    },
    switchEditing(index) {
      this.editingComponent = this.selectedComponents[index]
    },
    addComponent(e) {
      let index = e.newIndex
      if (index == this.selectedComponents.length) {
        index = index - 1
      }
      this.editingComponent = this.selectedComponents[index]
    },
    removeComponent(item) {
      var index = this.selectedComponents.indexOf(item)
      if (index >= 0) {
        this.selectedComponents.splice(index, 1)
      }
    },
    async postCreateNode() {
      let fields = this.selectedComponents.map((item, index) => {
        let type = item.type
        let f = {
          title: item.title,
          type: type,
          placeholder: item.placeholder,
          required: item.required,
          sort: index,
        }

        if (type == 3) {
          f.extra = {
            unit: item.unit,
          }
        } else if (type == 4 || type == 5) {
          f.extra = {
            options: item.options,
          }
        } else if (type == 6 || type == 7) {
          f.extra = {
            date_type: item.dateType,
          }
        }

        return f
      })

      if (!this.model) {
        this.node.step = this.step
      }

      if (this.mode == '1') {
        this.node.mode = 1
      } else if (this.mode == '2') {
        this.node.mode = 2 + parseInt(this.users.type)
        this.node.mode_value = this.users.values.join(',')
      } else {
        this.node.mode = 4 + parseInt(this.users.type)
        this.node.mode_value = this.users.values.join(',')
      }

      this.node.manhour = parseInt(this.node.manhour)
      if (!this.node.code) {
        this.errorMsg = '请选择工序名称'
        return
      }
      this.node.title = this.nodes[this.node.code].name
      let data = {
        node: this.node,
        fields: fields,
      }

      if (this.model && this.model.id > 0) {
        let res = await updateFlowNode(data)
        if (res.code == 0) {
          this.$emit('updated', res.data)
        }
        $('#NodeEditor').modal('hide')
        this.model = null
      } else {
        let res = await newFlowNode(data)
        if (res.code == 0) {
          this.$emit('created', res.data)
        }
        $('#NodeEditor').modal('hide')
      }
    },
    addOption() {
      var options = this.editingComponent.options
      var length = options.length
      let option = '选项' + ++length
      while (options.indexOf(option) >= 0) {
        option = '选项' + ++length
      }
      this.editingComponent.options.push(option)
    },
    removeOption(index) {
      this.editingComponent.options.splice(index, 1)
    },
    dispalyPlaceholder(type) {
      return [1, 2, 3].indexOf(type) != -1
    },
    dispalyInput(type) {
      return [1, 2, 3].indexOf(type) != -1
    },
    dispalyOptions(type) {
      return [4, 5].indexOf(type) != -1
    },
    displayDate(type) {
      return [6, 7].indexOf(type) != -1
    },
    repeatOption(index) {
      if (this.repeatOptionIndexes.length == 0) {
        return false
      } else {
        return this.repeatOptionIndexes.indexOf(index) != -1
      }
    },
    resetData() {
      this.node.id = null
      this.node.step = 0
      this.node.code = 0
      this.node.title = ''
      this.node.mode = 1
      this.node.mode_value = ''
      this.mode = '1'
      this.selectedComponents = []
      this.editingComponent = null
      this.users.type = 0
      this.users.values = []
      this.node.focus_checked = false
      this.node.imgs = []
      this.node.manhour = 0
      this.errorMsg = ''
      this.model = null
      $('#Tab a:first').tab('show')
    },
    async requestNodeDetail() {
      let res = await flowNodeDetail({
        id: this.nodeid,
      })
      this.model = res.data
      this.node.title = this.model.title
      this.node.code = this.model.code
      this.node.mode = this.model.mode
      this.node.mode_value = this.model.mode_value
      this.node.id = this.model.id
      this.node.manhour = this.model.manhour
      this.node.focus_checked = this.model.focus_checked
      this.node.imgs = this.model.imgs || []

      this.users = {
        type: this.node.mode == 3 || this.node.mode == 5 ? 1 : 0,
        values: this.node.mode_value.split(',').map((item) => {
          return parseInt(item)
        }),
      }
      switch (this.node.mode) {
        case 1:
          this.mode = '1'
          break
        case 2:
        case 3:
          this.mode = '2'
          break
        case 4:
        case 5:
          this.mode = '3'
          break
        default:
          this.mode = '1'
          break
      }
      // this.mode = this.node.mode == 1 ? '1' : '2'
      this.selectedComponents = this.model.form.fields.map((item) => {
        var extra = item.extra_json
        return {
          title: item.title,
          type: item.type,
          placeholder: item.placeholder,
          unit: extra ? extra.unit : '',
          required: item.required,
          options: extra ? extra.options : null,
          dateType: extra ? extra.date_type : '',
        }
      })
    },
  },
}
</script>

<style scoped>
.help-block {
  margin-bottom: 0 !important;
}
.panel-control {
  float: left;
}
.new-node-tabs {
  float: none;
  margin: 0 auto;
  width: 194px;
}

.editor {
  display: flex;
}

.form-components {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-components .item {
  width: 130px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 3px;
  line-height: 30px;
  display: flex;
  padding: 0 5px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  box-sizing: border-box;
  cursor: move;
}

.form-editor {
  flex: 1;
  height: auto;
  overflow: scroll;
  border: 1px dash #ccc;
  background: #f5f5f5;
  margin: 0 20px;
  position: relative;
}

.eidtor-zone {
  width: 100%;
  height: 100%;
}

.form-editor .no-tips {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 30px;
  text-align: center;
}

.component-set {
  width: 200px;
  height: auto;
  overflow: scroll;
}

.form-editor .form-group {
  margin: 10px 10px 0;
  padding: 10px;
  border: 1px dashed #f5f5f5;
  cursor: move;
  margin-bottom: 0;
  background-color: #fff;
}

.form-editor .form-group:hover {
  border: 1px dashed #03a9f8;
}

.form-editor .selected,
.form-editor .selected:hover {
  border: 1px solid #03a9f8;
}

.form-editor .item {
  height: 2px;
  background-color: red;
  overflow: hidden;
}
.control-label {
  font-weight: 600;
}
.info {
  color: #999;
}
.component-set .info {
  font-size: 12px;
  margin-left: 5px;
}
.edit-component {
  position: relative;
}

.edit-component .close {
  display: none;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  line-height: 20px;
  background-color: #ff0000;
  color: #fff;
  font-size: 12px;
}

.edit-component:hover .close {
  display: block;
}

.component-option {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 3px;
  height: 33px;
  overflow: hidden;
  background-color: #fff;
  margin-bottom: 5px;
}

.component-option.repeat {
  border-color: #ffb80f;
}

.component-option .move,
.component-option .delete {
  display: inline-block;
  width: 30px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  cursor: pointer;
}

.component-option .form-control {
  border: 0 none;
  padding: 0;
  flex: 1;
}
.date-component {
  display: flex;
  justify-content: space-between;
}
</style>
<style>
.node-popper-select {
  z-index: 10000 !important;
}
</style>